import React, { useEffect, useRef } from 'react';
import { Edit, Copy, Trash2, Settings } from 'lucide-react';

const ContextMenu = ({ id, top, left, onClose, onDelete, onDuplicate, onEdit }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };
    const handleEscape = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  const menuItems = [
    { label: 'Configure', icon: Settings, onClick: () => onEdit(id), color: 'var(--text)' },
    { label: 'Duplicate', icon: Copy,     onClick: () => onDuplicate(id), color: 'var(--text)' },
    { label: 'Delete',    icon: Trash2,   onClick: () => onDelete(id),    color: '#ff4e7a'    },
  ];

  return (
    <div
      ref={menuRef}
      className="context-menu"
      style={{
        position: 'fixed',
        top,
        left,
        zIndex: 9999,
        minWidth: 148,
        padding: '4px 0',
      }}
    >
      {menuItems.map((item) => {
        const Icon = item.icon;
        return (
          <button
            key={item.label}
            onClick={item.onClick}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              width: '100%',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '6px 12px',
              color: item.color,
              fontSize: '0.78rem',
              fontFamily: 'inherit',
              textAlign: 'left',
              letterSpacing: '0.04em',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = 'color-mix(in srgb, var(--accent) 12%, transparent)' }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'none' }}
          >
            <Icon size={13} />
            {item.label}
          </button>
        );
      })}
    </div>
  );
};

export default ContextMenu;
